module.exports = __webpack_public_path__ + "img/p99.849584ac.png";